import styles from "./ProgressBar.module.css";
import type { AsyncOperationProgress } from "../api/hooks/useAsyncOperation";

// Shared determinate/indeterminate progress bar for long-running operations.
// Fed the backend operation row's `progress` ({done, total, label}). When
// `total` is known it renders a determinate bar + "done / total"; when total
// is null (e.g. a Gmail search still gathering candidates) it renders an
// indeterminate sweep with just the label.
export const ProgressBar = ({
  progress,
}: {
  progress?: AsyncOperationProgress | null;
}) => {
  if (!progress) return null;
  const { done, total, label } = progress;
  const determinate = typeof total === "number" && total > 0;
  const pct = determinate ? Math.min(100, (done / total!) * 100) : 0;
  return (
    <div className={styles.wrap}>
      <div className={styles.row}>
        <span className={styles.label}>{label ?? "Working..."}</span>
        {determinate && (
          <span className={styles.count}>
            {done.toLocaleString()} / {total!.toLocaleString()}
          </span>
        )}
      </div>
      <div className={styles.track}>
        <div
          className={determinate ? styles.fill : styles.fillIndeterminate}
          style={determinate ? { width: `${pct}%` } : undefined}
        />
      </div>
    </div>
  );
};

export default ProgressBar;
